"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getFormatter = getFormatter;
exports.isValidAxisLabelFormatter = isValidAxisLabelFormatter;
exports.AxisLabelFormatters = void 0;

require("core-js/modules/es6.object.freeze");

var _defaultNumberLabel = _interopRequireDefault(require("./default-number-label"));

var _percentageLabel = _interopRequireDefault(require("./percentage-label"));

/**
 * @callback AxisLabelFormatter
 *
 * A function that is used to appropriately format axis labels.
 *
 * @param {AxisLabelFormatterOptions} - Passed valid AxisLabelFormatterOptions
 * @returns {string} - An appropriately formatted label to display on a visualization
 */

/**
 *
 * @param {ValueFormatters} name - The name of the desired formatter
 * @returns {AxisLabelFormatter} - The desired formatter function
 */
function getFormatter(name) {
  if (isValidAxisLabelFormatter(name)) {
    if (name === AxisLabelFormatters.DEFAULT_NUMBER_LABEL) {
      return _defaultNumberLabel.default;
    }

    if (name === AxisLabelFormatters.PASS_THROUGH) {
      return function (options) {
        return options.value;
      };
    }

    if (name === AxisLabelFormatters.PERCENTAGE_LABEL) {
      return _percentageLabel.default;
    }
  }

  throw new Error("Provided name is not a valid value formatter. Provided ".concat(name));
}
/**
 *
 * @param {string} type - String to validate
 * @returns {boolean} - True if valid, false if invalid
 */


function isValidAxisLabelFormatter(type) {
  return AxisLabelFormatters.hasOwnProperty(type);
}

var AxisLabelFormatters = {
  DEFAULT_NUMBER_LABEL: 'DEFAULT_NUMBER_LABEL',
  PASS_THROUGH: 'PASS_THROUGH',
  PERCENTAGE_LABEL: 'PERCENTAGE_LABEL'
};
exports.AxisLabelFormatters = AxisLabelFormatters;
Object.freeze(AxisLabelFormatters);